import { ActionTypes } from './model'
import { executeEvent } from '../360tour/action'


function isMobileDevice() {
    return window.innerWidth < 600;
}

export function selectItem(id) {
    return function (dispatch) {
        dispatch({
            type: ActionTypes.CHANGE_SELECT_ITEM,
            payload: id
        });
        dispatch(executeEvent((krpano) => {
            krpano.call(`loadscene(${id},null,MERGE,BLEND(0.5));`);
        }));

        if(isMobileDevice()){
            dispatch(changeNavStatus(true))
        }
    }
}

export function changeNavStatus(isCollapse) {
    return {
        type: ActionTypes.CHANGE_NAV_STATUS,
        payload: isCollapse
    }
}
